import LabelVisibilityController from "../../output/labels/labels/label-visibility-controller.js";

class DomLabelVisibilityController {
    setVisible(label, visible) {
        label.domElement.style.display = visible ? "block" : "none";
    }
}

export default DomLabelVisibilityController;
